import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { AdminFinancialReport } from "@/pages/admin/financial-report";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/admin/financial-report/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<AdminFinancialReport />
		</DashboardLayout>
	);
}
